var _path, _path2, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowserMockup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1814,
    height: 1020,
    viewBox: "0 0 1814 1020",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1814 0H0V1020H1814V0ZM1810 60H4V1002C4 1009.73 10.268 1016 18 1016H1796C1803.73 1016 1810 1009.73 1810 1002V60Z",
    fill: "#040C18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C8.9543 0 0 8.9543 0 20V1000C0 1011.05 8.95432 1020 20 1020H1794C1805.05 1020 1814 1011.05 1814 1000V20C1814 8.95431 1805.05 0 1794 0H20ZM1807 63H7V999C7 1006.73 13.268 1013 21 1013H1793C1800.73 1013 1807 1006.73 1807 999V63Z",
    fill: "#363D46"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 103,
    cy: 32,
    r: 11,
    fill: "#84C23E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 32,
    r: 11,
    fill: "#E3AC2D"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 32,
    r: 11,
    fill: "#DD6E62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserMockup);
export default __webpack_public_path__ + "static/media/browser_mockup.0c545d7264713c58bb6eb2c0957393bc.svg";
export { ForwardRef as ReactComponent };